import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UploadsService } from '../../services/uploads.service';
import * as UploadsUiActions from '../actions/uploads-ui.actions';
import * as UploadsApiActions from '../actions/uploads-api.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { IDjangoErrors } from '../../../../shared/models/DjangoErrors';

@Injectable()
export class UploadsEffects {
  private readonly actions$ = inject(Actions);
  private readonly uploadsService = inject(UploadsService);

  listGUIUploads$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UploadsUiActions.ListGUIUploads),
      mergeMap(() =>
        this.uploadsService.listGUIUploads().pipe(
          map((response) => UploadsApiActions.ListGUIUploadsSuccess({ payload: response })),
          catchError((error: IDjangoErrors) => of(UploadsApiActions.ListGUIUploadsFailure({ errors: error })))
        )
      )
    )
  );

  getGUIUploadDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UploadsUiActions.GetGUIUploadDetail),
      mergeMap(({ uploadId }) =>
        this.uploadsService.getGUIUploadDetail(uploadId).pipe(
          map((response) => UploadsApiActions.GetGUIUploadDetailSuccess({ payload: response })),
          catchError((error: IDjangoErrors) => of(UploadsApiActions.GetGUIUploadDetailFailure({ errors: error })))
        )
      )
    )
  );
}
